import React from 'react';

export const NotificationsButtonContext = React.createContext<{
  showNotifications: boolean;
  isSuggestion: boolean;
  defaultOpen?: boolean;
  setShowNotifications: (value: boolean) => void;
}>(Object.assign({}));
